import Vue from 'vue'
import VueX from 'vuex'
Vue.use(VueX);
import axios from 'axios'

const API_URL1 = window.config.API_URL1;
const API_URL2 = window.config.API_URL2;
const ARTICLE = window.config.ARTICLE;
const NEWURL = window.config.APP_URL3;
export default new VueX.Store({
    state: {
        showNotice:false
    },
    mutations: {
        changeNotice (state) {
            state.showNotice = !state.showNotice;
        }
    },
    actions: {
        getVerifyCode({}, info){
            return axios.get(API_URL1 + '/apph5/api/verify?phone='+info.phone)
        },
        getAppMessage({},info){
            var config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.get(API_URL1 + '/apph5/app-message?app_id='+info.app_id+'&orderno='+info.orderno , config_)
        },
        addOrderContact({}, info){
            var config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.post(API_URL1 + '/apph5/order/add-contact', info.info, config_)
        },
        getCommentDetail({}, info){
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                }
            };
            return axios.get(API_URL1 + '/apph5/comment/show?id='+info.id , config_)
        },
        orderComment({}, info){
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.post(API_URL1 + '/apph5/comment/service', info.info, config_)
        },
        searchMailBoxMsg({}, info){
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                }
            };
            return axios.get(API_URL1 + '/apph5/mailbox/latest?app_id='+info.app_id , config_)
        },
        getEngArrangement({}, info){
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                }
            };
            return axios.get(API_URL1 + '/apph5/api/arrangement?eng_no='+info.eng_no+"&date_from="+info.date_from+"&date_to="+info.date_to,config_)
        },
        getMessages({}, info){
            let path = API_URL1 + '/apph5/mailbox/messages?app_id='+info.info.app_id
            if(info.info.order_no){
                path = path + '&order_no='+info.info.order_no
            }
            if(info.info.last_id){
                path = path + '&last_id='+info.info.last_id
            }
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                }
            };
            return axios.get(path, config_)
        },
        getEngineerInfo({}, info){
            return axios.get(API_URL1 + '/apph5/engineer/view?eng_no='+info.eng_no)
        },
        createQrCode({}, info){
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
                responseType: 'blob'
            };
            return axios.get(API_URL1 + '/apph5/order/qr-code?qr_code='+info.qr_code, config_)
        },
        getSvrInfo({}, info){
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.get(API_URL1 + '/apph5/order/svr-qr-payment?sorder_no='+info.sorder_no+'&type='+info.type+'&redirect='+info.redirect, config_)
        },
        getPayInfo({}, info){
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.get(API_URL1 + '/apph5/order/qr-payment?orderno='+info.orderno+'&type='+info.type+'&redirect='+info.redirect, config_)
        },
        bindPhone({},info){
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.post(API_URL2 + '/v1/bind/phone', info, config_ )
        },
        loginQQ({}, info) {
            return axios.post(API_URL2 + '/v1/login/qq', info)
        },
        getEngineers({}, info){
            let path = API_URL1 + '/apph5/engineer?page='+info.page
            if(info.order_by){
                path = path+'&order_by='+info.order_by+'&order_dir='+info.order_dir
            }
            if(info.gid){
                path = path + "&gid="+info.gid
            }
            return axios.get(path)
        },
        getServiceMessage({},info){
            return axios.get(API_URL1 + '/apph5/goods/messages?api_version='+info.api_version+'&gid='+info.gid)
        },
        getGoodsInfo({},info){
            return axios.get(API_URL1 + '/apph5/goods/info?api_version='+info.api_version+'&gid='+info.gid)
        },
        getHomeGoods({}, info){
            return axios.get(API_URL1 + '/apph5/goods?api_version='+info.api_version+'&app_id='+info.app_id)
        },
        getSystemConfig({}, info){
            return axios.get(API_URL1 + '/apph5/api?app_id='+info.app_id)
        },
        submitDiggme({}, info) {
            return axios.post(API_URL1 + '/apph5/feedback/mind-test', info)
        },
        getGoodsList({}, info) {
            return axios.get(API_URL1 + '/apph5/goods?app_id=' + info.app_id + '&api_version=' + info.api_version)
        },
        getCountryCodes({}, info) {
            return axios.get(API_URL2 + '/v1/country-codes', info)
        },
        getSms({}, info) {
            return axios.post(API_URL2 + '/v1/sms', info)
        },
        login({}, info) {
            return axios.post(API_URL2 + '/v1/login/phone', info)
        },
        logout({}, info) {
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token
                },
            };
            return axios.post(API_URL2 + '/v1/logout', "", config_)
        },
        refresh({}, info) {
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token
                },
            };
            return axios.post(API_URL2 + '/v1/token/refresh', { 'refresh_token': info.refresh_token }, config_)
        },
        // getGoodsInfo({}, info) {
        //     return axios.post(API_URL1 + '/apph5/goods/info?gid=' + info.gid + '&api_version=' + info.api_version)
        // },
        submitQuestionnaire({}, info) {
            var config_ = {};
            if (info.access_token) {
                config_ = {
                    headers: {
                        'Authorization': 'Bearer ' + info.access_token,
                        'Content-Type': 'application/json'
                    },
                };
            }
            return axios.post(API_URL1 + '/apph5/feedback/answers', info.info, config_)
        },
        feedback({}, info) {
            var config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.post(API_URL1 + '/apph5/feedback/add-feedback', info.info, config_)
        },
        addContact({}, info) {
            return axios.post(API_URL1 + '/apph5/feedback/add-contact', info)
        },
        createOrder({}, info) {
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.post(API_URL1 + '/apph5/order/create', info.info, config_)
        },
        // wapPay({}, info) {
        //     let config_ = {
        //         headers: {
        //             'Authorization': 'Bearer ' + info.access_token,
        //         },
        //     };
        //     return axios.get(API_URL1 + '/apph5/order/wap-payment?orderno=' + info.orderno + '&type=' + info.type + '&return_url=' + info.return_url, config_)
        // },
        wapPay({}, { return_url, orderno, type, sorder_no, hb_fq_num}) {
            console.log(return_url, orderno, type, sorder_no)
            let payUrl = 'wap-payment';
            let params = null;
            if(!sorder_no){
                params = {
                    orderno,
                    type,
                    return_url
                };
            }else{
                params = {
                    sorder_no,
                    type,
                    return_url
                };
                payUrl = 'svr-wap-payment';
            }

            if(hb_fq_num){
                params['hb_fq_num'] = hb_fq_num
            }

            let config_ = {
                params,
                headers: {
                    'Authorization': 'Bearer ' + localStorage.access_token,
                },
            };
            return axios.get(API_URL1 + '/apph5/order/' + payUrl, config_)
        },
        inWxPay({},{ orderno }){
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.access_token,
                },
            };
             return axios.get(API_URL1 + '/apph5/order/wap-payment?orderno=' + orderno + '&type=wxpay', config_)
            // return axios.get(API_URL1 + '/apph5/order/wap-payment?orderno=' + orderno + '&type=wxpay', config_)
        },
        wapPay_svr({}, info) {
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.get(API_URL1 + '/apph5/order/svr-wap-payment?sorder_no=' + info.sorder_no + '&type=' + info.type + '&return_url=' + info.return_url, config_)
        },
        getOrderList({}, info) {
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.get(API_URL1 + '/apph5/api/orders?page=' + info.page+'&app_id=' + info.app_id+'&api_version=' + info.api_version, config_)
        },
        getOdinfo({}, info) {
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.get(API_URL1 + '/apph5/api/odinfo-v2?orderno=' + info.orderno, config_)
        },
        getSodingo({}, info) {
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.get(API_URL1 + '/apph5/order/s-order-info?sorder_no=' + info.sorder_no, config_)
        },
        cancelOrder({}, info) {
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.get(API_URL1 + '/apph5/order/cancel?orderno=' + info.orderno, config_)
        },
        deleteOrder({}, info) {
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.get(API_URL1 + '/apph5/order/delete?orderno=' + info.orderno + '&api_version=' + info.api_version, config_)
        },
        getUserinfo({}, info) {
            let config_ = {
                headers: {
                    'Authorization': 'Bearer ' + info.access_token,
                },
            };
            return axios.get(API_URL2 + '/v1/userinfo', config_)
        },
        getArticles({}, info) {
            return axios.get(ARTICLE + '/api?json=get_category_posts&count=' + info.count + '&page=' + info.page + '&category_slug=' + info.category_slug + '')
        },
        getDetail({}, info) {
            return axios.get(ARTICLE + '/api?json=get_post&post_id=' + info.id)
        },
        setArticleViews({}, id) {
            let config_ = {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                },
            };
            return axios.get(ARTICLE + '/api?json=PV&id=' + id, config_)
        },
        getConsultList({}, info){
          let config_ = {
            headers: info.access_token? {
                'Authorization': 'Bearer ' + info.access_token,
              }:{},
          };
          return axios.get(NEWURL + '/discussion/discussions?page=' + info.page, config_)
          // return axios.get(API_URL1 + '/apph5/goods?api_version='+info.api_version+'&app_id='+info.app_id)

        },
        getConsultDetail({}, info){
          let config_ = {
            headers: info.access_token? {
              'Authorization': 'Bearer ' + info.access_token,
            }:{},
          };
          return axios.get(NEWURL + '/discussion/discussions/' + info.id, config_)
        },
        setGood({}, info){
          let config_ = {
            headers: {
              'Authorization': 'Bearer ' + info.access_token,
              'Content-Type': 'application/json'
            },
          };
          return axios.patch(NEWURL + '/discussion/discussions/' + info.id, {
            like_it: info.like_it
          }, config_)
        },


    }
})



// WEBPACK FOOTER //
// ./src/store/index.js